import { render, staticRenderFns } from "./AgilePickupDeclaredValuePackTable.vue?vue&type=template&id=ed6698b6&scoped=true"
import script from "./AgilePickupDeclaredValuePackTable.vue?vue&type=script&lang=ts"
export * from "./AgilePickupDeclaredValuePackTable.vue?vue&type=script&lang=ts"
import style0 from "./AgilePickupDeclaredValuePackTable.vue?vue&type=style&index=0&id=ed6698b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6698b6",
  null
  
)

export default component.exports